export enum MessageType {
  ERROR = 'error',
  ALERT = 'alert',
  INFO = 'info',
  SUCCESS = 'success'
}
